import React from 'react';

import PropTypes from 'prop-types';
import { FaPhone, FaEnvelope, FaUser } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import WithBackground from '../Common/WithBackground';

import './style.css';

const EmployerTeam = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const managementContacts = [
    {
      id: 1,
      name: t('partners.contacts.marcinProniewicz.name'),
      position: t('partners.contacts.marcinProniewicz.position'),
      phone: t('partners.contacts.marcinProniewicz.phone'),
      email: t('partners.contacts.marcinProniewicz.email'),
    },
    {
      id: 2,
      name: t('partners.contacts.volodymyrHladun.name'),
      position: t('partners.contacts.volodymyrHladun.position'),
      phone: t('partners.contacts.volodymyrHladun.phone'),
      email: t('partners.contacts.volodymyrHladun.email'),
    },
    {
      id: 3,
      name: t('partners.contacts.ewaDowhan.name'),
      position: t('partners.contacts.ewaDowhan.position'),
      phone: t('partners.contacts.ewaDowhan.phone'),
      email: t('partners.contacts.ewaDowhan.email'),
    },
  ];

  const teamContent = (
    <section className='employer-team'>
      <div className='employer-team__container'>
        <div className='employer-team__header'>
          <h2 className='employer-team__title'>
            {t('partners.contacts.title')}
          </h2>
          <p className='employer-team__intro'>{t('partners.cta.subtitle')}</p>
        </div>

        <div className='employer-team__grid'>
          {managementContacts.map((contact) => (
            <div key={contact.id} className='employer-team-card'>
              <div className='employer-team-card__header'>
                <div className='employer-team-card__avatar'>
                  <FaUser />
                </div>
                <div className='employer-team-card__info'>
                  <h3 className='employer-team-card__name'>{contact.name}</h3>
                  <p className='employer-team-card__position'>
                    {contact.position}
                  </p>
                </div>
              </div>

              <div className='employer-team-card__contact'>
                <div className='employer-team-card__contact-item'>
                  <FaPhone />
                  <a
                    href={`tel:${contact.phone}`}
                    className='employer-team-card__contact-link'
                  >
                    {contact.phone}
                  </a>
                </div>
                <div className='employer-team-card__contact-item'>
                  <FaEnvelope />
                  <a
                    href={`mailto:${contact.email}`}
                    className='employer-team-card__contact-link'
                  >
                    {contact.email}
                  </a>
                </div>
              </div>

              <div className='employer-team-card__action'>
                <a
                  href={`tel:${contact.phone}`}
                  className='employer-team-card__contact-btn'
                >
                  <FaPhone />
                  {t('partners.contacts.callButton')}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {teamContent}
    </WithBackground>
  ) : (
    teamContent
  );
};

EmployerTeam.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

EmployerTeam.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default EmployerTeam;
